import {
  instance as axios,
  setJwtToken,
} from "../../config/axiosInstance";

export const getCustomerProblemListApi = async (data) => {
  const endPoint = `/admin/user/customer-problem-list`;
  return await axios.post(endPoint, data, setJwtToken());
};

// Fetch counts for all problem types in one request (parallel on server)
export const getCustomerProblemStatsAllApi = async (filter = {}) => {
  const params = new URLSearchParams();
  if (filter.timeRange) params.append("timeRange", filter.timeRange);
  if (filter.startDate) params.append("startDate", filter.startDate);
  if (filter.endDate)   params.append("endDate",   filter.endDate);
  const query = params.toString() ? `?${params.toString()}` : "";
  return await axios.get(`/admin/user/customer-problem-stats-all${query}`, setJwtToken());
};

// Fetch count for a single problem type with optional date filter
export const getCustomerProblemStatSingleApi = async (type, filter = {}) => {
  const params = new URLSearchParams();
  if (filter.timeRange) params.append("timeRange", filter.timeRange);
  if (filter.startDate) params.append("startDate", filter.startDate);
  if (filter.endDate) params.append("endDate", filter.endDate);
  const query = params.toString() ? `?${params.toString()}` : "";
  const endPoint = `/admin/user/customer-problem-stats/${type}${query}`;
  return await axios.get(endPoint, setJwtToken());
};

// Save / update a remark for a specific user + problem category
export const saveCustomerRemarkApi = async ({ userId, problemType, remark, contextKey }) => {
  return await axios.post(
    `/admin/user/customer-remark`,
    { userId, problemType, remark, ...(contextKey ? { contextKey } : {}) },
    setJwtToken()
  );
};

// Bulk fetch remarks for a list of userIds in a problem category
export const getCustomerRemarksBulkApi = async ({ userIds, problemType, remarkTargets }) => {
  return await axios.post(
    `/admin/user/customer-remarks-bulk`,
    remarkTargets?.length
      ? { problemType, remarkTargets }
      : { userIds, problemType },
    setJwtToken()
  );
};

// ── Completed Chat Call APIs ──────────────────────────────────────────────────

export const getCompletedChatCallStatsApi = async (filter = {}) => {
  const params = new URLSearchParams();
  if (filter.timeRange) params.append("timeRange", filter.timeRange);
  if (filter.startDate) params.append("startDate", filter.startDate);
  if (filter.endDate)   params.append("endDate",   filter.endDate);
  const q = params.toString() ? `?${params.toString()}` : "";
  return await axios.get(`/admin/user/completed-chat-call/stats${q}`, setJwtToken());
};

export const getCompletedChatCallListApi = async (data) =>
  await axios.post(`/admin/user/completed-chat-call/list`, data, setJwtToken());

export const getCompletedChatCallRecordApi = async (waitlistId) =>
  await axios.get(`/admin/user/completed-chat-call/record/${waitlistId}`, setJwtToken());

export const saveCompletedChatCallTagApi = async (data) =>
  await axios.post(`/admin/user/completed-chat-call/tag`, data, setJwtToken());

export const removeCompletedChatCallTagApi = async (waitlistId, tagType) =>
  await axios.delete(`/admin/user/completed-chat-call/tag/${waitlistId}/${tagType}`, setJwtToken());

export const addCompletedChatCallEvidenceApi = async (formData) =>
  await axios.post(`/admin/user/completed-chat-call/evidence`, formData, {
    ...setJwtToken(),
    headers: { ...setJwtToken().headers, "Content-Type": "multipart/form-data" },
  });

export const addCompletedChatCallNoteEvidenceApi = async (data) =>
  await axios.post(`/admin/user/completed-chat-call/evidence`, data, setJwtToken());

export const deleteCompletedChatCallEvidenceApi = async (waitlistId, evidenceId) =>
  await axios.delete(`/admin/user/completed-chat-call/evidence/${waitlistId}/${evidenceId}`, setJwtToken());

export const getCompletedChatHistoryApi = async (waitlistId) =>
  await axios.get(`/admin/user/completed-chat-call/chat-history/${waitlistId}`, setJwtToken());

export const getCompletedChatSummaryStatsApi = async (data) =>
  await axios.post(`/admin/user/completed-chat-call/summary-stats`, data, setJwtToken());
